import { type SVGProps } from "react";

interface IProps extends SVGProps<SVGSVGElement> {}

export const Youtube = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 40 40"
      {...props}
    >
      <path
        fill="inherit"
        d="M32.074 16.037c-.152-1.467-.48-3.09-1.684-3.942-.932-.662-2.158-.686-3.303-.685l-7.26.006-6.98.006c-.973.002-1.918-.074-2.82.347-.776.36-1.383 1.048-1.748 1.812-.506 1.063-.612 2.268-.673 3.443a56 56 0 0 0 .034 6.427c.099 1.562.35 3.287 1.557 4.283 1.07.88 2.58.924 3.967.925q6.607.008 13.216.011a16 16 0 0 0 1.73-.072c1.132-.122 2.211-.446 2.939-1.285.734-.846.923-2.023 1.034-3.138a40.2 40.2 0 0 0-.01-8.138M17.28 23.832v-7.583l6.565 3.79z"
      />
    </svg>
  );
};
